module.exports = __webpack_public_path__ + "img/Banner5中文.e7faf379.png";